import { FC } from 'react';
import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';
import './Layout.scss';
import Navigation from './Navigation';
import GlobalFooter from './GlobalFooter';
import { AppRoutes } from 'Constants';

type LayoutProps = { children?: JSX.Element };

const Layout: FC<LayoutProps> = () => {
    const location = useLocation();
    const isLogoutPage = location.pathname === AppRoutes.LogoutPage;

    return (
        <>
            <div className={!isLogoutPage ? 'background-img' : ''}>
                <Navigation />
                <main
                    role="main"
                    className="ap-container page-container mt-4 remove-padding flex column"
                >
                    <Outlet />
                </main>
                <ScrollRestoration />
                {!isLogoutPage && <GlobalFooter />}
            </div>
        </>
    );
};

export default Layout;
